import { render } from "./ModalRemoveSaleChannels.vue?vue&type=template&id=6a6c1436"
import script from "./ModalRemoveSaleChannels.vue?vue&type=script&lang=js"
export * from "./ModalRemoveSaleChannels.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__